import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../../utils/IDS";
import { GET, POST } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import Cookies from "js-cookie";

export const GetSuccessSpeaks = createAsyncThunk(
  "website/home/success-speaks",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home.Success_Speaks}?language=${filter?.language || ""}`,
      );
      return res.data;
      // return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllFAQ = createAsyncThunk(
  "website/home/all-faq",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home?.HomeFaq}?language=${filter?.language || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAboutUsOurStory = createAsyncThunk(
  "website/aboutus/our-story",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home?.AboutUsOurStory}?language=${filter?.language || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetInTouch = createAsyncThunk(
  "website/contact-us/get-in-touch",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home?.ContactUsGetInTouch}?language=${filter?.language || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllUniversity = createAsyncThunk(
  "website/home/all-univerisity",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Home?.getAllUniversity);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllOurProcess = createAsyncThunk(
  "website/home/all-our-process",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home?.getAllOurProcess}?language=${filter?.language || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllMeetOurTeam = createAsyncThunk(
  "website/home/all-meet-our-team",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home?.getAllMeetOurTeam}?language=${filter?.language || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllCountry = createAsyncThunk(
  "website/home/all-country",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Home?.getAllCountry}?language=${filter?.language}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Slice = createSlice({
  name: "auth",
  initialState: {
    all_success_speaks: [],
    all_faq: [],
    all_aboutUsOurStory: [],
    all_contact_us_get_in_touch: [],
    all_university: [],
    all_our_process: [],
    all_meet_our_team: [],
    all_country: [],
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder

      .addCase(GetSuccessSpeaks.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSuccessSpeaks.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_success_speaks = action.payload || [];
      })
      .addCase(GetSuccessSpeaks.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllFAQ.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllFAQ.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faq = action.payload || [];
      })
      .addCase(GetAllFAQ.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAboutUsOurStory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAboutUsOurStory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_aboutUsOurStory = action.payload || [];
      })
      .addCase(GetAboutUsOurStory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetInTouch.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetInTouch.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_contact_us_get_in_touch = action.payload || [];
      })
      .addCase(GetInTouch.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllUniversity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllUniversity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_university = action.payload || [];
      })
      .addCase(GetAllUniversity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllOurProcess.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllOurProcess.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_our_process = action.payload || [];
      })
      .addCase(GetAllOurProcess.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllMeetOurTeam.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllMeetOurTeam.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_meet_our_team = action.payload || [];
      })
      .addCase(GetAllMeetOurTeam.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(GetAllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
